import trackToString from "./trackToString";

/**
 * Converts a cup array to a string that looks like a bulleted list.
 * @param {Array} cup An array of Track objects
 * @returns String list (with line feeds) of track info.
 */
export default function cupToString(cup) {
    let string = "";
    cup.map((element) => string += `- ${trackToString(element)}\n`);
    return string;
}